import { Injectable, inject } from '@angular/core';
import { UserClient } from '@api';
import { Observable, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { AddButtonType } from '../models/add-button-type.model';
import { IAddButtonConfig } from '../models/table.base.model';

@Injectable({
  providedIn: 'root',
})
export class TableService {
  private userClient = inject(UserClient);

  config = <IAddButtonConfig>{
    label: 'crud.add',
  };

  initAddButton$(type: AddButtonType): Observable<IAddButtonConfig> {
    switch (type) {
      case AddButtonType.ENABLED:
        return of(<IAddButtonConfig>{
          label: this.config.label,
          disabled: false,
        });
      case AddButtonType.RENTAL_CONTRACT:
        return this.isAddDisabledRentalContract().pipe(
          switchMap((disabled: boolean) => {
            return of(<IAddButtonConfig>{
              label: this.config.label,
              disabled,
            });
          })
        );
      default:
        throw Error('initAddButton not implemented');
    }
  }

  private isAddDisabledRentalContract(): Observable<boolean> {
    return new Observable<boolean>(observer => {
      this.userClient.getRentalContractForUser().subscribe(
        value => {
          observer.next(value == null);
        },
        () => {
          observer.next(true);
        }
      );
    });
  }
}
